import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BreadcrumbService {
    oldIndex = 0;
    newIndex = 0;
    constructor() { }

    items$ = new BehaviorSubject<any>([
        {
            text: 'Portal',
            title: 'Portal',
            path: 'portal'
        }
    ])

    addChild(item: any) {
        const currentItems = this.items$.value;
        if (currentItems.some((p: any) => p.title !== item.title)) {
            this.items$.next([...currentItems, item]);
        }
    }

    addParent(item: any) {
        this.items$.next([item]);
    }

    updateBreadcrumb(item: any) {
        this.oldIndex = window.location.href.split('/').length;
        const currentItems = this.items$.value;
        console.log(currentItems, 'currentItemsss');
        if (currentItems.some((p: any) => p.title === item.title)) {
            currentItems.pop();
            if (item.path == 'portal' && currentItems.length > 1) {
                currentItems.pop();
            }
        }
        this.items$.next([...currentItems]);
    }

    resetCrumb() {
        this.items$.next([
            {
                text: 'Portal',
                title: 'Portal',
                path: 'portal'
            }
        ]);
    }
}
